<template>
  <div class="outer-wrapper">
      <div class="title">
        <p>工序管理</p>
    </div>
    <Tabs>
      <TabPane label="全部工序" icon="logo-buffer">
        <query-list
          :columnsFormatData="columnsFormatData"
          :askData="askData"
          :refreshData="update_count"
          main_width="1280px"
        ></query-list>
      </TabPane>
      <Button @click="openModal('newCreate')" slot="extra" type="primary">新增工序</Button>
    </Tabs>
    <Modal
      v-model="modalValue.newCreate"
      :width="600"
      :mask-closable="false"
      :closable="false"
    >
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>新建工序</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>工序名称：</td>
              <td>
                <input
                  type="text"
                  placeholder="工序名称"
                  v-model="name"
                  style="width:400px;"
                />
              </td>
            </tr>
            <tr>
              <td>工序代码：</td>
              <td>
                <input
                  type="text"
                  placeholder="工序代码"
                  v-model="label"
                  style="width:400px;"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="newCreateSubmit('newCreate')"  >提交</Button>
        <Button size="large" @click="closeModal('newCreate')" >取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import queryList from "@/components/Common/QueryList.vue";
let userToken = localStorage.getItem("current_user_token");
//import shellExpand from "./ShellExpand.vue";


export default {
  name: "processManage",
  props: [],
  components: {
    queryList
  },
  data() {
    return {
      op_name: this.$options.name,
      askData: "processList",
      update_count: 0,
      modalValue:{
          newCreate:false,
      },
      name:'',
      label:"",
      columnsFormatData: [
        {
          title: "名称",
          key: "name",
          align: "center"
        },
        {
          title: "代码",
          key: "label",
          align: "center"
        },
        {
          title: "创建时间",
          key: "record_time",
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red",marginRight:'5px' },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              ),
              
            ]);
          }
        }
        
      ]
    };
  },
  computed:{

  },
  methods: {
    openModal(value){
        this.modalValue[value] = true;
    },
    closeModal(value){
        this.modalValue[value] = false;
    },
    confirmBox(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content:
          "<p>" +
          "工序：" +
          value.name +          
          "</p>",
        onOk: () => {
          this.recordFormatDel(value.label);
        },
        onCancel: () => {}
      });
    },
    recordFormatDel(id) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delProcess",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    newCreateSubmit(value){
      let form = new FormData();
        form.append("userToken", userToken);
        form.append("label", this.label);
        form.append("name", this.name);
        form.append("askData", "createProcess");
        let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
        this.$axios
          .post(this.$url + "/process", form, config)
          .then(response => {
            if (response.data.stat === "ok") {
              this.$Message.success("新建成功！");
              this.update_count++;
              this.closeModal(value);
            } else {
              this.$Message.error(response.data.info);
            }
          })
          .catch(error => {
            this.$Message.error(error + "未知错误！");
          });
    },
  }
};
</script>
<style scoped>
.outer-wrapper{
    width:1280px;
    margin:0 auto;
}
.title{
  text-align: center;
  margin:10px auto;
  font-size:20px;

}
.cr-form{
    width:100%;
    border-collapse: collapse;
}

.cr-form td{
    height:45px;
}

.cr-form td:first-child{
    text-align: right;
}

.cr-form input{
    padding: 0 10px;
    outline: none;
    height:30px;
    border-radius: 2px;
    border:1px solid #aaa;
}
</style>